import styled from "styled-components";

interface FloatingButtonStyleProps {
  $nav?: boolean;
}

export const FloatingButton = styled.button<FloatingButtonStyleProps>`
  width: 64px;
  right: 16px;
  height: 64px;
  bottom: ${(props) => (props.$nav === true ? "86px" : "0")};
  border: none;
  z-index: 99;
  position: fixed;
  background: ${(props) => props.theme.colors.primary100};
  box-shadow: ${(props) => props.theme.shadows.floatBtn};
  border-radius: 50%;

  svg {
    path {
      fill: ${(props) => props.theme.colors.white100};
    }
  }

  &:active {
    box-shadow: none;
  }
`;
